import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation, Trans } from 'react-i18next';

export type DateRangeLimitModalProps = {
  open: boolean;
  onClose: () => void;
  maxDays: number;
  onRequestOneDrive?: () => void;
  oneDriveDisabled?: boolean;
};

const DateRangeLimitModal = ({
  open,
  onClose,
  maxDays,
  onRequestOneDrive,
  oneDriveDisabled = false,
}: DateRangeLimitModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('shared.dateRangeLimitModal.title')}</DialogTitle>
      <DialogContent>
        <Typography>
          <Trans
            i18nKey="shared.dateRangeLimitModal.body1"
            values={{ maxDays }}
            components={{
              bold: <Typography component="span" fontWeight={700} />,
            }}
          />
        </Typography>

        <Typography sx={{ mt: 1 }}>
          <Trans
            i18nKey="shared.dateRangeLimitModal.body2"
            components={{
              bold: <Typography component="span" fontWeight={700} />,
            }}
          />
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{t('navigation.buttons.close')}</Button>
        {/* <Button variant="contained" onClick={onRequestOneDrive} disabled={oneDriveDisabled}>
          {t('reports.dateRangeLimitModal.requestOneDrive')}
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default DateRangeLimitModal;
